/**
 * Helper to dynamically resolve canonical URLs and domain origins 
 * across aapligaadi.co.in, aapligaadi.com, and aapligaadi.in
 */
export const getCanonicalUrl = (path: string = ""): string => {
    const origin = (typeof window !== "undefined" && window.location && window.location.origin) 
        ? window.location.origin 
        : "https://www.aapligaadi.co.in";
    const cleanPath = path.startsWith("/") ? path : `/${path}`;
    return `${origin}${cleanPath}`;
};

export const getDomainOrigin = (): string => {
    return (typeof window !== "undefined" && window.location && window.location.origin)
        ? window.location.origin
        : "https://www.aapligaadi.co.in";
};
